import { Routes } from '@angular/router';

export const getBindersRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./get-binders.page').then((m) => m.GetBindersPage),
  },
];
